import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from '../styled';
import DetailTitle from 'modules/Common/DetailTitle';
import { DetailNotFound } from './styled';
import { compose, withProps } from 'recompose';
import { Spacer } from '@ontruck/orc';
import { injectIntl } from 'react-intl';

const enhance = compose(
  withProps(({ stop = {} }) => ({
    comments: stop.comments || [],
    appointmentInstructions: stop.appointment_instructions,
  }))
);

const CommentsRow = React.memo(({ comments, appointmentInstructions, intl }) => {
  const t = intl.messages.components.StopCard;
  return (
    <StyledRow data-testid="comments-row">
      {!!comments?.length && (
        <Fragment>
          <Spacer mBottom="M">
            <DetailTitle>{t.comment}</DetailTitle>
            {comments
              .join('\n')
              .split('\n')
              .map((comment, key) => (
                <div data-testid="comments-row_comment" key={key}>
                  {comment}
                </div>
              ))}
          </Spacer>
        </Fragment>
      )}
      {!!appointmentInstructions && (
        <Fragment>
          <DetailTitle>{t.appointment_instructions}</DetailTitle>
          <div data-testid="comments-row_appointment-instructions">{appointmentInstructions}</div>
        </Fragment>
      )}
      {!comments?.length && !appointmentInstructions && (
        <DetailNotFound>{t.no_instructions}</DetailNotFound>
      )}
    </StyledRow>
  );
});

CommentsRow.propTypes = {
  comments: PropTypes.array,
  appointmentInstructions: PropTypes.string,
};

export default enhance(injectIntl(CommentsRow));
